import {
    INCREMENT_PAGE,
    SET_PAGE,
    SET_LOADING,
    SET_DONE,
    SET_TOTAL_PAGES,
    SET_LIST,
    SET_SEARCH_VALUE,
    SET_CATEGORIA_ID,
    SET_APPLIED_FILTERS
} from './mutation-types'
import produtoService from '@/services/produtos/produtoService'

export default {
    setSearchValue({ commit, state, dispatch }, value) {
        if (state.filtersEdit.search !== value) {
            commit(SET_SEARCH_VALUE, value);
            commit(SET_PAGE, 1);
            commit(SET_DONE, false);
            dispatch("fetchAll");
        }
    },

    setCategoriaId({ commit, state, dispatch }, param) {
        const { categoriaId, fetchProdutos } = param || {};
        if (state.filtersEdit.categoriaId !== categoriaId) {
            commit(SET_CATEGORIA_ID, categoriaId);
            commit(SET_SEARCH_VALUE, "");
            commit(SET_PAGE, 1);
            commit(SET_DONE, false);
            if (fetchProdutos)
                dispatch("fetchAll");
        }
    },

    incrementPage({ commit, dispatch }) {
        commit(INCREMENT_PAGE);
        dispatch("fetchAll");
    },

    fetchAll({ commit, state }) {
        if (state.done || state.page < 1) return;
        if (JSON.stringify(state.filtersEdit) === JSON.stringify(state.appliedFilters)) return;

        if (state.filtersEdit.page === 1)
            commit(SET_LIST, []);

        commit(SET_LOADING, true);
        produtoService.fetchAll(state.filtersEdit.page, state.filtersEdit.search, state.filtersEdit.categoriaId)
            .then(res => {
                commit(SET_LIST, [...state.produtos, ...res.data.produtos]);
                commit(SET_TOTAL_PAGES, res.data.quantidadeDePaginas);
                commit(SET_DONE, state.totalPages <= state.filtersEdit.page);
            })
            .catch(error => {
                const { data } = error.response;
                console.error(data);
            })
            .finally(() => {
                commit(SET_APPLIED_FILTERS, { ...state.filtersEdit })
                commit(SET_LOADING, false);
            });
    }
}